import { Component, OnInit } from '@angular/core';
import cssVars from 'css-vars-ponyfill';

@Component({
    selector: 'app-fraud-language',
    templateUrl: './fraud-language.component.html',
    styleUrls: ['./fraud-language.component.css'],
    standalone: true
})
export class FraudLanguageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    cssVars();
  }

}
